// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_bv-b";
export var colorBlue = "_bv-8";
export var colorDot = "_bv-0";
export var colorDotLarge = "_bv-2";
export var colorDotSmall = "_bv-1";
export var colorGreen = "_bv-7";
export var colorGrey = "_bv-3";
export var colorOrange = "_bv-5";
export var colorPink = "_bv-a";
export var colorPurple = "_bv-9";
export var colorRed = "_bv-4";
export var colorYellow = "_bv-6";